import { render } from "./expertOverviewForm.vue?vue&type=template&id=4ee35edd&ts=true"
import script from "./expertOverviewForm.vue?vue&type=script&lang=ts"
export * from "./expertOverviewForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__